// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Core__JSON from "@rescript/core/src/Core__JSON.bs.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Caml_js_exceptions from "rescript/lib/es6/caml_js_exceptions.js";
import * as Utils$OrcaPaymentPage from "./Utils.bs.js";

function parseSdkNextActionError(json) {
  var dict = Utils$OrcaPaymentPage.getDictFromJson(json);
  var nextAction = Utils$OrcaPaymentPage.getDictFromDict(dict, "sdk_next_action")["next_action"];
  if (nextAction === undefined) {
    return ;
  }
  var str = Core__JSON.Classify.classify(nextAction);
  if (typeof str !== "object") {
    return ;
  }
  switch (str.TAG) {
    case "String" :
        if (str._0 === "deny") {
          return "";
        } else {
          return ;
        }
    case "Object" :
        return Core__Option.map(str._0["deny"], (function (denyJson) {
                      return Utils$OrcaPaymentPage.getString(Utils$OrcaPaymentPage.getDictFromJson(denyJson), "message", "");
                    }));
    default:
      return ;
  }
}

function parseEligibilitySurchargeDetails(dict) {
  return Core__Option.flatMap(dict["surcharge_details"], (function (surchargeJson) {
                var surchargeDict = Utils$OrcaPaymentPage.getDictFromJson(surchargeJson);
                var surchargeInnerDict = Utils$OrcaPaymentPage.getDictFromDict(surchargeDict, "surcharge");
                var displayTotal = Utils$OrcaPaymentPage.getFloat(surchargeDict, "display_total_surcharge_amount", 0.0);
                if (displayTotal > 0.0) {
                  return {
                          surcharge: {
                            type: Utils$OrcaPaymentPage.getString(surchargeInnerDict, "type", ""),
                            value: Utils$OrcaPaymentPage.getFloat(surchargeInnerDict, "value", 0.0)
                          },
                          taxOnSurcharge: Core__Option.flatMap(surchargeDict["tax_on_surcharge"], (function (v) {
                                  var n = Core__JSON.Classify.classify(v);
                                  if (typeof n !== "object" || n.TAG !== "Number") {
                                    return ;
                                  } else {
                                    return n._0;
                                  }
                                })),
                          displaySurchargeAmount: Utils$OrcaPaymentPage.getFloat(surchargeDict, "display_surcharge_amount", 0.0),
                          displayTaxOnSurchargeAmount: Utils$OrcaPaymentPage.getFloat(surchargeDict, "display_tax_on_surcharge_amount", 0.0),
                          displayTotalSurchargeAmount: displayTotal
                        };
                }
                
              }));
}

function parseEligibilityResponse(json) {
  var dict = Utils$OrcaPaymentPage.getDictFromJson(json);
  var eligibilityError = parseSdkNextActionError(json);
  var surchargeDetails = parseEligibilitySurchargeDetails(dict);
  return {
          eligibilityError: eligibilityError,
          surchargeDetails: surchargeDetails
        };
}

async function performEligibilityCheck(clientSecret, publishableKey, logger, customPodUri, bodyArr, sdkAuthorization, endpoint, signal, shouldBlockConfirm, setIsEligibilityPending, setEligibilitySurchargeDetails, setEligibilityError, errorLogMessage, fetchEligibility) {
  setEligibilitySurchargeDetails(function (param) {
        
      });
  if (shouldBlockConfirm) {
    setIsEligibilityPending(function (param) {
          return true;
        });
  }
  try {
    var json = await fetchEligibility(clientSecret, publishableKey, logger, customPodUri, bodyArr, sdkAuthorization, endpoint, signal);
    var match = parseEligibilityResponse(json);
    var surchargeDetails = match.surchargeDetails;
    var eligibilityError = match.eligibilityError;
    Core__Option.forEach(setEligibilityError, (function (setter) {
            setter(function (param) {
                  return eligibilityError;
                });
          }));
    setEligibilitySurchargeDetails(function (param) {
          return surchargeDetails;
        });
    return setIsEligibilityPending(function (param) {
                return false;
              });
  }
  catch (raw_exn){
    var exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
    logger.setLogError(Core__Option.getOr(JSON.stringify({
                  message: errorLogMessage,
                  error: JSON.stringify(exn)
                }), ""), "PAYMENT_METHOD_ELIGIBILITY_CALL", undefined, undefined, undefined, undefined, undefined);
    Core__Option.forEach(setEligibilityError, (function (setter) {
            setter(function (param) {
                  
                });
          }));
    return setIsEligibilityPending(function (param) {
                return false;
              });
  }
}

async function startEligibilityCheck(controllerRef, clientSecret, publishableKey, logger, customPodUri, bodyArr, sdkAuthorization, endpoint, shouldBlockConfirm, setIsEligibilityPending, setEligibilitySurchargeDetails, setEligibilityError, errorLogMessage, fetchEligibility) {
  Core__Option.forEach(controllerRef.current, (function (c) {
          c.abort();
        }));
  var controller = new AbortController();
  controllerRef.current = Caml_option.some(controller);
  var signal = controller.signal;
  if (clientSecret !== undefined) {
    return await performEligibilityCheck(clientSecret, publishableKey, logger, customPodUri, bodyArr, sdkAuthorization, endpoint, signal, shouldBlockConfirm, setIsEligibilityPending, setEligibilitySurchargeDetails, setEligibilityError, errorLogMessage, fetchEligibility);
  }
  
}

function getCardEligibilityErrorText(cardEligibilityError, localeString) {
  if (cardEligibilityError !== undefined && cardEligibilityError !== "") {
    return cardEligibilityError;
  } else {
    return localeString.cardNotEligibleText;
  }
}

export {
  parseSdkNextActionError ,
  parseEligibilitySurchargeDetails ,
  parseEligibilityResponse ,
  performEligibilityCheck ,
  startEligibilityCheck ,
  getCardEligibilityErrorText ,
}
/* Utils-OrcaPaymentPage Not a pure module */
